// extracted by mini-css-extract-plugin
module.exports = {"slidecontainer":"slider_slidecontainer__3Ro8d","slidephoto":"slider_slidephoto__10erK","newsText":"slider_newsText__3WLgd"};